import { createAction } from '@reduxjs/toolkit';

const resetAll = createAction('GYNGER_RESET_ALL');
export default resetAll;
